const prefix = 'ACTIVITY/';

export const SET_URL_PARAMS = `${prefix}SET_URL_PARAMS`;
